import React from 'react';
import PropTypes from 'prop-types';

class Banner extends React.Component {
  render() {
    const { imageUrl } = this.props;

    if (!imageUrl) { return null; }

    return (
      <div className="map-explorer__header__banner">
        <img alt="" src={imageUrl} />
      </div>
    );
  }
}

Banner.defaultProps = {
  imageUrl: null,
};

Banner.propTypes = {
  imageUrl: PropTypes.string,
};

export default Banner;
